import GoExternalGameBase from '#BASE/components/externalGame/externalGame.go.component';
import audiovisual from 'BASE/components/audiovisual/audiovisual.component';
import CollectionComponent from 'CJ/components/collection/collection.component';
import userFeedback_component from 'CJ/views/Feedback';
import LotteryMenuComponent from 'CJ/views/LotteryMenu';

import * as gameMenu from 'BASE/common/menu/menu.game';
import { storage } from 'BASE/common/util/util.storage';
import gameCollectionStore from 'BASE/store/bet/bet.store.collection';
import { getterTypes, actionTypes } from 'BASE/store/types';
import { GameTag, getGameTag, getVRGameTag } from 'BASE/common/gameTag';
import enternalGameList from 'BASE/common/externalGame/externalGameList';

export default {
    name: 'LeftSideDrawLobby',
    mixins: [GoExternalGameBase,CollectionComponent,audiovisual],
    components: {
        userFeedback_component,
        LotteryMenuComponent,
    },
    data() {
        return {
            display:true,
            isShowLeftSideMenu: false,
            gameTag: GameTag,
            gameMenus: {},            
            vrMenus: [],            
            vrPrefix: 'VR_',
            activedTab: '',
            gameList: enternalGameList,

            editCollectedGame: [],
            dialogFavoriteEditName: 'favoriteEdit',
            dialogFavoriteListName: 'favoriteList',
            dialogLotteryListName: 'lotteryList',
            dialogOtherListName: 'gameList',
            tabLiveName: 'live',
            tabSlotName: 'slot',
            tabCardName: 'card',
            tabSportName: 'sport',
        };
    },
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        userName() {
            return this.$store.state.userinfo.userName;
        },
        LotteryMenu() {
            if (!this.gameMenus.homeLeft || this.gameMenus.homeLeft.Items.length <= 0)
                return [];

            let leftMenu = gameMenu.mergeInfo(this.gameMenus.homeLeft, [this.gameDatas]);
            if (Object.keys(leftMenu).length !== 0) {
                leftMenu.forEach(category => {
                    category.Items.forEach(game => {
                        game.Tag = getGameTag(game.LotteryGameHotNewState);
                    });
                });
            }
            return leftMenu;
        },
        VrMenu() {
            if (Object.keys(this.vrMenus).length <= 0)
                return [];

            let vrItems = JSON.parse(JSON.stringify(this.vrMenus));
            for (let game of vrItems) {
                game.Tag = getVRGameTag(this.vrPrefix + game.GameCode);
            }
            return vrItems;
        },
        collectedGame() {
            return this.$store.getters[getterTypes.BET_GET_COLLECTIONS];
        },
        collectedGames() {
            let result = [];
            if (Object.keys(this.gameDatas).length <= 0) {
                return [];
            }

            if (this.collectedGame.length > 0) {
                // 玩家收藏的彩種
                result = this.mergeInfo(this.collectedGame, [this.gameDatas]).filter(g => !g.Offline && this.gameMenus.homeLeft.gameIds.findIndex(c => c.toString() === g.Id.toString()) >=0);
            }
            if (this.gameMenus.defaultCollection && result.length === 0){
                // 預設顯示的彩種
                result = this.mergeInfo(this.gameMenus.defaultCollection.gameIds, [this.gameDatas]).filter(g => !g.Offline && this.gameMenus.homeLeft.gameIds.findIndex(c => c.toString() === g.Id.toString()) >=0);
            }

            return result;
        },
        CollectedMenu() {
            let favoriteMenu = [];
            this.LotteryMenu.forEach(category => {
                let items = category.Items.filter(item => this.collectedGames.findIndex(c => c.Id.toString() === item.Id.toString()) >= 0);
                if (items.length > 0) {
                    let newCategory = JSON.parse(JSON.stringify(category));
                    newCategory.Items = items;
                    favoriteMenu.push(newCategory);
                }
            });
            return favoriteMenu;
        },
        activeDialog() {
            switch (this.activedTab) {
                case this.tabLiveName:
                case this.tabSlotName:
                case this.tabCardName:
                case this.tabSportName:
                    return this.dialogOtherListName;
                default:
                    return this.activedTab;
            }
        }
    },
    watch:{
        "$route.name": function (val, oldVal) {
            let _this = this;
            _this.display = true;
            if(val == "DrawHistory" || val == "Register" || val == "Timeout" || val == "IPRestricted" || val == "ErrorMsg" || val == "LinkFailure" || val == "Offline"){
                _this.display = false;
            }
        },
        "$route.fullPath": function (val, oldVal) {
            if(this.activeDialog != ''){
                this.hideDialog();
            }
        }
    },
    methods: {
        switchLeftSideMenu() {
            this.isShowLeftSideMenu = !this.isShowLeftSideMenu;
            storage.local.set(storage.keys.LEFT_MENU_STATE, this.isShowLeftSideMenu);
        },
        showFeedback() {
            if(this.$refs && this.$refs.Feedback)
            {
                this.$refs.Feedback.showFeedback();
            }
        },
        mergeInfo(collected, objs) {
            let res = [];
            let _this = this;
            if (!collected || objs.some(o => !o)) {
                return res;
            }

            for (let _gameId of collected) {
                let infos = {};
                infos = objs.map(o => o[_gameId]);
                if (infos.every(i => i)) {
                    res.push(Object.assign({ Id: _gameId }, ...infos));
                }
            }
            return res;
        },
        showDialog(tab) {
            if(this.activeDialog){
                this.hideDialog();
            }
            this.activedTab = tab;
            this.$dialog.get(this.activeDialog).show();
        },
        hideDialog() {
            this.$dialog.get(this.activeDialog).hide();
            this.activedTab = '';
        },
        showFavoriteEdit(){  
            this.editCollectedGame = this.collectedGames.map(g => g.Id.toString())//.slice();            
            this.hideDialog();
            this.showDialog(this.dialogFavoriteEditName);
        },

        chooseCollect(val) { //選擇收藏
            let valStr = val.toString();
            let _checkCollect = this.editCollectedGame;
            if (_checkCollect.indexOf(valStr) > -1) {
                //已選須取消
                let index = _checkCollect.findIndex(e => e == valStr);
                if (index >= 0) {
                    _checkCollect.splice(index, 1);
                }
            } else {
                if (_checkCollect.length >= this.maxCollect) this.$dialog.warning('已添加彩种已满。'); //自定义彩种已满提示
                else _checkCollect.push(valStr);
            }
        },

        clearCollect() {
            this.editCollectedGame = [];
        },

        async saveCollected() { //儲存快捷
            if (this.collectedGames.length === this.editCollectedGame.length && this.collectedGame.every((id, index) => id === this.editCollectedGame[index])) {
                    this.hideDialog();
                    return;
            }

            this.$store.dispatch(actionTypes.BET_SET_COLLECTIONS, { userName : this.userName, gameIdArr : this.editCollectedGame, collectionType : this.collectionType });
            this.hideDialog();
        },
    },    
    async mounted() {
        let state = storage.local.get(storage.keys.LEFT_MENU_STATE);
        if(state == null){
            state = true;
            storage.local.set(storage.keys.LEFT_MENU_STATE, state);
        }
        this.isShowLeftSideMenu = state;

        let _this = this;
        const gameMenus = gameMenu.get();
        const vrMenus = this.getVRLottery();   // 取得VR彩票
        const collectedGame = this.$store.dispatch(actionTypes.BET_GET_COLLECTIONS, { userName: _this.userName, collectionType: _this.collectionType});

        gameMenus.then(r => _this.gameMenus = r);
        vrMenus.then(r => _this.vrMenus = r);

        await Promise.all([gameMenus, vrMenus, collectedGame]);
    },
    beforeCreate() {
        if(this.$store.state.gameCollection) {
            this.$store.unregisterModule('gameCollection');
        }
        this.$store.registerModule('gameCollection', new gameCollectionStore());
    },
    beforeDestroy() {
        this.$store.unregisterModule('gameCollection');
    },
}